import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ModulesContext = createContext(null);

export function ModulesProvider({ children }) {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/modules");
      setModules(data.data || []);
    } catch (error) {
      // 401 is already handled by the api interceptor; log other failures
      if (error?.response?.status !== 401) {
        console.error("Failed to load modules:", error);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const toggle = async (key, enabled) => {
    const { data } = await api.put(`/modules/${key}`, { is_enabled: enabled });
    setModules(data.data || []);
    return data.cascaded || []; // expose to caller for UX feedback
  };

  const isEnabled = (key) => {
    const m = modules.find((x) => x.module_key === key);
    return m ? m.is_enabled : true;
  };

  return (
    <ModulesContext.Provider value={{ modules, loading, refresh, toggle, isEnabled }}>
      {children}
    </ModulesContext.Provider>
  );
}

export const useModules = () => useContext(ModulesContext);
